import moment from "moment";
import {
  PASSWORD_LENGTH_MSG,
  PASSWORD_SPECIAL_CHAR_MSG,
  PASSWORD_CHAR_MSG,
  PASSWORD_NO_SPACE_MSG,
  NEW_PASSWORD_MSG
} from "../../../utils/translationKeys";

// TO GET FORMATED PRICE TO 2 DECIMALS
export const getFormatedPrice = (num) => {
  return Math.round((num + Number.EPSILON) * 100) / 100;
};

// TO GET FORMATED DATE
export const getFormatedDate = (date, formatType) => {
  return moment(date).format(formatType);
};

// TO GET CURRENT DATE
export const getCurrentDate = () => {
  return moment().format("YYYY-MM-DD");
};

// TO GET SELECTED ASSOCIATED CUSTOMER
export const getSelectedAssociatedCustomer = () => {
  return localStorage.getItem("selectedCustomerID");
};

// TO GET SELECTED ASSOCIATED CUSTOMER Type
export const getSelectedAssociatedCustomerType = () => {
  return localStorage.getItem("selectedCustomerType");
};

// TO GET SELECTED ASSOCIATED CUSTOMER Sap ID
export const getSelectedAssociatedCustomerSapId = () => {
  return localStorage.getItem("selectedCustomerSapId");
};

// TO GET SELECTED ASSOCIATED CUSTOMER Credit Amount
export const getSelectedAssociatedCustomerCreditAmt = () => {
  return localStorage.getItem("selectedCustomerCreditAmt");
};

// TO GET DEFAULT ROUTES ACCESSIBLE TO ALL USER
export const getDefaultRoutes = () => {
  return [
    { key: "home", link: "Home" },
    { key: "my-account", link: "My Account" },
    { key: "change-password", link: "Change Password" },
    { key: "cart-preview", link: "Cart Preview" },
    { key: "cart-summary", link: "Cart Summary" },
    { key: "health", link: "Health" },
    { key: "order-summary", link: "Order Summary" },
    { key: "order-details", link: "Order Details" },
    { key: "bulk-upload", link: "Bulk Upload" },
    { key: "suggested-order-detail", link: "Suggested Order Details" },
    { key: "project-details", link: "Project Details" }
  ]
};

// TO GET PROJECT SEARCH FIELDS
export const getProjectSearchFields = () => {
  return [
    "Project Code",
    "Project Name"
  ];
}

// TO GET USER ID
export const getUserId = () => {
  return localStorage.getItem("userId");
}

// TO SET DYNAMIC MESSAGE AND CHECK FOR SPECIFIC STRING TO REPLACE
export const setDynamicErrorMessage = (originalMsg, remainingAttempts, placeholderKey = '{REMAININGPASSWORDATTEMPT}') => {
  // Check if the placeholder exists in the original message    
  if (originalMsg.includes(placeholderKey)) {
    // Replace the placeholder with the actual remaining attempts
    const dynamicErrorMsg = originalMsg.replace(
      placeholderKey, 
      remainingAttempts.toString()
    );      
    return dynamicErrorMsg;
  }    
  // If no placeholder found, return the original message
  return originalMsg;
}

// TO GET PASSWORD NOTIFICATION FORMAT FOR CHANGE & RESET PASSWORD
export const getPasswordNotificationFormat = (translate) => {
  return (
    <>
      <p>{translate(PASSWORD_LENGTH_MSG)}</p>
      <p>{translate(PASSWORD_SPECIAL_CHAR_MSG)}</p>
      <p>{translate(PASSWORD_CHAR_MSG)}</p>
      <p>{translate(PASSWORD_NO_SPACE_MSG)}</p>
    </>
  )
}